import React from "react";
import { Box } from "@mui/system";
import { MRT_ColumnDef } from "material-react-table";
import { Site } from "api";
import { CustomMaterialTable } from "components";

export const AllocationDetailsTable = ({ columns, data }: { columns: MRT_ColumnDef<Site>[]; data: Site[] }) => (
    <Box data-testid="allocation-details-table-root" sx={{ flex: 1, overflow: "auto" }}>
        <CustomMaterialTable
            data={data}
            columns={columns}
            enablePagination={false}
            enableColumnResizing
            muiTableContainerProps={{
                sx: {
                    "& thead tr:first-of-type th": {
                        "& > div": { justifyContent: "center", paddingRight: "8px" },
                    },
                    height: "calc(100vh - 405px)",
                    width: "calc(100vw - 150px)",
                },
            }}
        />
    </Box>
);